import React, { useState, useEffect } from 'react';
import { api } from '../../api';

const KioscoSection = () => {
  const [aditamento, setAditamento] = useState('');
  const [wifiSsid, setWifiSsid] = useState('');
  const [wifiPassword, setWifiPassword] = useState('');
  const [incluirWifi, setIncluirWifi] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState('');

  // Buscar PIN existente para un aditamento
  const [buscandoPin, setBuscandoPin] = useState(false);
  const [pinExistente, setPinExistente] = useState(null);

  const generarQR = async () => {
    if (!aditamento.trim()) {
      setError('Ingresá el número de aditamento');
      return;
    }
    setError('');
    setResultado(null);
    setLoading(true);
    try {
      const body = { aditamento: aditamento.trim() };
      if (incluirWifi && wifiSsid.trim()) {
        body.wifi_ssid = wifiSsid.trim();
        body.wifi_password = wifiPassword;
      }
      const data = await api.post('/kiosko/qr', body);
      setResultado(data);
    } catch (err) {
      setError(err.message || 'Error generando QR');
    } finally {
      setLoading(false);
    }
  };

  const buscarPin = async () => {
    if (!aditamento.trim()) {
      setError('Ingresá el número de aditamento');
      return;
    }
    setError('');
    setPinExistente(null);
    setBuscandoPin(true);
    try {
      const data = await api.get(`/kiosko/pin/${aditamento.trim()}`);
      setPinExistente(data);
    } catch (err) {
      if (err.message && err.message.includes('404')) {
        setError('No existe dispositivo kiosco para ese aditamento. Generá el QR primero.');
      } else {
        setError(err.message || 'Error consultando PIN');
      }
    } finally {
      setBuscandoPin(false);
    }
  };

  const descargarQR = () => {
    if (!resultado?.qr_base64) return;
    const link = document.createElement('a');
    link.href = resultado.qr_base64;
    link.download = `qr-kiosco-aditamento-${resultado.aditamento}.png`;
    link.click();
  };

  const copiarMensajeWhatsapp = () => {
    if (!resultado) return;
    const msg = `*Cyker - Configuración de Taxímetro Digital*\n\nHola! Te enviamos el QR para configurar tu celular como taxímetro.\n\n*Aditamento:* ${resultado.aditamento}\n*PIN de recuperación:* ${resultado.pin_recovery}\n\n_Guardá este PIN en un lugar seguro. Es el único modo de recuperar el dispositivo si algo falla._\n\nInstrucciones:\n1. Formateá el celular (factory reset)\n2. En la pantalla de bienvenida, tocá 6 veces\n3. Escaneá el QR que te adjuntamos\n4. Esperá 5 minutos mientras se configura solo`;
    navigator.clipboard.writeText(msg).then(() => {
      alert('Mensaje copiado al portapapeles. Ahora pegalo en WhatsApp.');
    });
  };

  return (
    <div style={{ padding: '24px', maxWidth: '700px' }}>
      <h2 style={{ marginBottom: '8px', color: '#444242' }}>📱 Kiosco Device Owner</h2>
      <p style={{ color: '#666', marginBottom: '24px', lineHeight: 1.5 }}>
        Generá el QR de provisioning para configurar un celular como taxímetro dedicado.
        El celular debe estar recién formateado. El PIN de recuperación se guarda de forma permanente.
      </p>

      {/* Formulario */}
      <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginBottom: '24px' }}>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: '6px', color: '#444242' }}>
            Número de Aditamento *
          </label>
          <input
            type="text"
            value={aditamento}
            onChange={e => setAditamento(e.target.value)}
            placeholder="Ej: 1234"
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px', boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', userSelect: 'none' }}>
            <input
              type="checkbox"
              checked={incluirWifi}
              onChange={e => setIncluirWifi(e.target.checked)}
            />
            <span style={{ fontWeight: 600, color: '#444242' }}>Incluir configuración WiFi (opcional)</span>
          </label>
          <p style={{ color: '#888', fontSize: '13px', marginTop: '4px', marginLeft: '24px' }}>
            Si lo activás, el celular se conectará automáticamente al WiFi al configurarse.
          </p>
        </div>

        {incluirWifi && (
          <div style={{ marginLeft: '24px', marginBottom: '16px', padding: '16px', background: '#f8f9fa', borderRadius: '8px' }}>
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontWeight: 500, marginBottom: '4px' }}>Nombre de red (SSID)</label>
              <input
                type="text"
                value={wifiSsid}
                onChange={e => setWifiSsid(e.target.value)}
                placeholder="Nombre de la red WiFi"
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: 500, marginBottom: '4px' }}>Contraseña WiFi</label>
              <input
                type="text"
                value={wifiPassword}
                onChange={e => setWifiPassword(e.target.value)}
                placeholder="Contraseña"
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
          </div>
        )}

        {error && (
          <div style={{ background: '#fff5f5', border: '1px solid #fc8181', borderRadius: '8px', padding: '12px', marginBottom: '16px', color: '#c53030' }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button
            onClick={generarQR}
            disabled={loading}
            style={{ background: '#74C8D2', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '8px', fontSize: '15px', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Generando...' : '🔲 Generar QR'}
          </button>
          <button
            onClick={buscarPin}
            disabled={buscandoPin}
            style={{ background: 'white', color: '#444242', border: '2px solid #ddd', padding: '12px 24px', borderRadius: '8px', fontSize: '15px', fontWeight: 600, cursor: buscandoPin ? 'not-allowed' : 'pointer' }}
          >
            {buscandoPin ? 'Buscando...' : '🔑 Ver PIN existente'}
          </button>
        </div>
      </div>

      {/* PIN existente */}
      {pinExistente && !resultado && (
        <div style={{ background: '#fffbeb', border: '1px solid #f6e05e', borderRadius: '12px', padding: '20px', marginBottom: '24px' }}>
          <h3 style={{ margin: '0 0 12px', color: '#744210' }}>🔑 PIN de Recovery</h3>
          <p style={{ margin: '0 0 4px' }}><strong>Aditamento:</strong> {pinExistente.aditamento}</p>
          <p style={{ margin: '0 0 4px', fontSize: '24px', letterSpacing: '4px', fontWeight: 700, color: '#744210' }}>{pinExistente.pin_recovery}</p>
          <p style={{ margin: '8px 0 0', color: '#888', fontSize: '13px' }}>
            QR generado el: {new Date(pinExistente.qr_generado_at).toLocaleString('es-AR')}
          </p>
        </div>
      )}

      {/* Resultado QR */}
      {resultado && (
        <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          <h3 style={{ margin: '0 0 16px', color: '#444242' }}>
            {resultado.es_nuevo ? '✅ QR Generado' : '♻️ QR Regenerado (PIN existente)'}
          </h3>

          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
            <div style={{ textAlign: 'center' }}>
              <img src={resultado.qr_base64} alt="QR Provisioning" style={{ width: '200px', height: '200px', border: '8px solid white', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', borderRadius: '4px' }} />
            </div>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <div style={{ marginBottom: '12px' }}>
                <span style={{ color: '#888', fontSize: '13px' }}>Aditamento</span>
                <p style={{ margin: '2px 0 0', fontWeight: 700, fontSize: '18px' }}>{resultado.aditamento}</p>
              </div>
              <div style={{ marginBottom: '20px', background: '#fff5f5', padding: '12px', borderRadius: '8px', border: '1px solid #fc8181' }}>
                <span style={{ color: '#888', fontSize: '13px' }}>PIN de Recovery (guardar)</span>
                <p style={{ margin: '4px 0 0', fontWeight: 700, fontSize: '28px', letterSpacing: '6px', color: '#c53030' }}>{resultado.pin_recovery}</p>
                <p style={{ margin: '6px 0 0', color: '#c53030', fontSize: '12px' }}>⚠️ Este PIN no se puede recuperar si se pierde</p>
              </div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button
                  onClick={descargarQR}
                  style={{ background: '#444242', color: 'white', border: 'none', padding: '10px 18px', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: 600 }}
                >
                  ⬇️ Descargar QR
                </button>
                <button
                  onClick={copiarMensajeWhatsapp}
                  style={{ background: '#25D366', color: 'white', border: 'none', padding: '10px 18px', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: 600 }}
                >
                  💬 Copiar mensaje WhatsApp
                </button>
              </div>
            </div>
          </div>

          <div style={{ marginTop: '20px', background: '#f0fff4', border: '1px solid #9ae6b4', borderRadius: '8px', padding: '16px' }}>
            <strong style={{ color: '#276749' }}>Instrucciones para el propietario:</strong>
            <ol style={{ margin: '8px 0 0', paddingLeft: '20px', color: '#276749', lineHeight: 1.8 }}>
              <li>Formatear el celular (ajustes → reseteo de fábrica)</li>
              <li>Encender el celular y en la pantalla de bienvenida <strong>tocar 6 veces</strong></li>
              <li>Escanear el QR con la cámara del setup</li>
              <li>Esperar ≈5 minutos mientras se configura automáticamente</li>
              <li>Cyker va a abrirse solo y quedar bloqueado como taxímetro</li>
            </ol>
          </div>
        </div>
      )}
    </div>
  );
};

export default KioscoSection;
